import React from 'react';

// Soglie sul primo testo (tempo percepito dalla persona)
export function classeLatenza(ms) {
  if (ms === null || ms === undefined) return 'salab-lat--nd';
  if (ms < 1000) return 'salab-lat--ok';
  if (ms < 2500) return 'salab-lat--medio';
  return 'salab-lat--lento';
}

export const fmtMs = (ms) => (ms === null || ms === undefined ? 'n/d' : `${Math.round(ms)} ms`);

/** Riga di latenza sotto una risposta dell'assistente. */
export default function LatenzaBadge({ tempi, meta }) {
  if (!tempi && !meta) return null;
  const estrazione = tempi?.estrazione_ms ?? meta?.estrazione_ms ?? null;
  const salvate = Array.isArray(meta?.salvate) ? meta.salvate : [];
  const scartate = Array.isArray(meta?.scartate) ? meta.scartate : [];

  return (
    <div className="salab-lat-row">
      {tempi && (
        <span className={`salab-lat ${classeLatenza(tempi.primo_token_ms)}`}>
          estrazione {fmtMs(estrazione)} · primo testo {fmtMs(tempi.primo_token_ms)} · totale {fmtMs(tempi.totale_ms)}
        </span>
      )}
      {salvate.length > 0 && (
        <span className="salab-lat salab-lat--info" title="Voci salvate dall'estrazione in questo turno">
          salvate: {salvate.join(', ')}
        </span>
      )}
      {scartate.length > 0 && (
        <span className="salab-lat salab-lat--nd" title="Voci estratte ma scartate in questo turno">
          scartate: {scartate.map((s) => (typeof s === 'string' ? s : s?.codice || JSON.stringify(s))).join(', ')}
        </span>
      )}
    </div>
  );
}
